<template>
  <div class="course">
    <figure class="course__thumb">
      <img :src="course.thumb" />
    </figure>

    <div class="course__text">
      <h2 class="course__name text-truncate">{{ course.name }}</h2>
      <h3 class="course__author">{{ course.authors_name }}</h3>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      course: { type: Object, required: true }
    }
  }
</script>


<style scoped lang="scss">
  .course {
    width: 340px;
    box-shadow: 0px 0px 30px 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    overflow: hidden;

    &__thumb {
      img { width: auto; max-width: 100%; border-radius: 10px }
    }

    &__text {
      display: flex;
      justify-content: center;
      flex-direction: column;
      padding: 15px 30px;
    }

    &__name {
      color: #313131;
      font-size: 1rem;
      font-weight: 500;
    }

    &__author {
      color: #717171;
      font-size: 0.9375rem;
      font-weight: 500;
    }
  }
</style>